export default __webpack_public_path__ + "static/main-codeplatform-ai-2ea3c8a6fbb592384ee2879bd4294919.png";